var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.44553V1H4.14673L5.83338 2.64282L5.83346 2.64289C5.98047 2.78612 6.17964 2.875 6.3971 2.875H11V3.44553H6H1ZM6 4.44553H11V10H1V4.44553H6ZM0.83 0C0.313462 0 0 0.453723 0 0.875V3.94553V10.125C0 10.5463 0.313477 11 0.83 11H11.17C11.6866 11 12 10.5463 12 10.125V3.94553V2.75C12 2.32874 11.6866 1.875 11.17 1.875H6.47828L4.79156 0.232105L4.79155 0.232099C4.64458 0.0889494 4.44543 0 4.22793 0H0.83ZM6.70833 6.40073V5.00244L8.83316 7.0789L6.70833 9.1973V7.79901H3.16695V6.40073H6.70833Z",
    fill: "#126973",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveFile);
export default __webpack_public_path__ + "static/media/move-file.9912141c92e77dd42ea977daf83fb631.svg";
export { ForwardRef as ReactComponent };